import React from 'react';

import { COMMITMENT_VIEWS } from './commitmentViews';

import SegmentedControl from 'CommonComponents/SegmentedControl';

/**
 * The Committed / Uncommitted / Total switch above the Cashflow Forecast report.
 *
 * Total is the default. Committed and Uncommitted re-base the department, second-level
 * and section subtotal rows onto that half of the figures; tax, balances, net cashflow
 * and the best/worst case rows always stay on total figures. In-memory only — the
 * selection resets on reload.
 */
export default function CommitmentViewControl({ value, onChange, className }) {
    const options = [
        { value: COMMITMENT_VIEWS.TOTAL, label: $t('Total') },
        { value: COMMITMENT_VIEWS.COMMITTED, label: $t('Committed') },
        { value: COMMITMENT_VIEWS.UNCOMMITTED, label: $t('Uncommitted') },
    ];

    return <SegmentedControl options={options} value={value} onChange={onChange} className={className} variant="default" />;
}
